import type { InsightConfig } from './types';

export const insightsRegistry: Record<string, InsightConfig> = {
  customer_journey_timeline: {
    id: 'customer_journey_timeline',
    label: "One customer's journey",
    renderer: 'journeyTimeline',
    source: { generator: 'revival_story_selector' },
  },
  inventory_watchlist: {
    id: 'inventory_watchlist',
    label: "What we're paying attention to",
    renderer: 'insightList',
    source: { generator: 'inventory_watchlist_job' },
  },
  discussion_item_packet: {
    id: 'discussion_item_packet',
    label: 'Discussion items',
    renderer: 'numberedInsightList',
    source: { generator: 'monthly_checkin_summarizer' },
  },
  monthly_focus_narrative: {
    id: 'monthly_focus_narrative',
    label: 'Heading into this month',
    renderer: 'narrativeBlock',
    source: { generator: 'looking_ahead_narrative' },
  },
};
